const debug                 = false;
myApp.nativeUI.options      = {};

//
// Open Options Window
myApp.nativeUI.options.init = function () {
    if(debug) console.log('Open Options Menu');

    // Make sure our window does not exist yet (to avoid, that we open it up twice)
    if(myApp.optionsWindow)
        return false;

    // Create a new Window element for our Options menu
    myApp.optionsWindow = myApp.nw.Window.open('resources/views/options.html', {
        position: 'center',
        width: 600,
        height: 350,
        resizable: false,
        focus: true
    } , function(win) {
        myApp.optionsWindow = win;

        // Get the Tray button, that links to this menu & disable it.
        // Makes the user aware the options are already open & prevents multiple calls
        let trayButton = myApp.nativeUI.tray.menu.items.filter(obj => { return obj.label === 'Options'; });
        trayButton[0].enabled = false;

        //
        // Register Element events

        // Focus hack, to ensure the options window remains always focused
        myApp.mainWindow.on('focus', function() {
            myApp.optionsWindow.focus();
        });

        // Clear up all linked data from our Object
        myApp.optionsWindow.on('closed', function() {
            trayButton[0].enabled   = true;
            myApp.optionsWindow     = null;
            myApp.optionsWindow.removeAllListeners('focus');
        });
    });
};